import { ref } from "vue";

export default {
  refCache: {},

  init() {
    // make sure CONFIG exists and make it a reactive proxy object, so Vue components can react to changes
    // when changed from outside Vue (e.g. from a browser extension) call configurationProvider.refreshAll() to update all refs

    if (!window.CONFIG) {
      window.CONFIG = {};
    }

    window.CONFIG = new Proxy(window.CONFIG, {
      set: (obj, prop, value) => {
        console.log(`ConfigurationProvider: setting ${prop} to ${value}`);
        obj[prop] = value;

        if (this.refCache[prop]) {
          this.refCache[prop].value = value;
        }

        return true;
      },
      get: (obj, prop) => {
        return obj[prop];
      },
    });
  },

  refreshAll() {
    Object.keys(this.refCache).forEach((key) => {
      var value = window?.CONFIG?.[key];
      if (value == undefined || value == null) {
        value = this.refCache[key].value;
      }

      if (this.refCache[key]) {
        this.refCache[key].value = value;
      }
    });
  },

  getStringRef(key, defaultValue = undefined) {
    var value = window?.CONFIG?.[key];
    if (value == undefined || value == null) {
      value = defaultValue;
    }

    if (value && typeof value != "string") {
      if (typeof value == "object") {
        value = JSON.stringify(value);
      } else {
        value = value + "";
      }
    }

    if (!this.refCache[key]) {
      this.refCache[key] = ref(value);
    } else {
      this.refCache[key].value = value;
    }

    return this.refCache[key];
  },

  getDoubleRef(key, defaultValue = undefined) {
    var value = window?.CONFIG?.[key];
    if (value == undefined || value == null || isNaN(value)) {
      value = defaultValue;
    } else {
      value = parseFloat(value);
    }

    if (!this.refCache[key]) {
      this.refCache[key] = ref(value);
    } else {
      this.refCache[key].value = value;
    }

    return this.refCache[key];
  },

  getIntRef(key, defaultValue = undefined) {
    var value = window?.CONFIG?.[key];
    if (value == undefined || value == null || isNaN(value)) {
      value = defaultValue;
    } else {
      value = parseInt(value);
    }

    if (!this.refCache[key]) {
      this.refCache[key] = ref(value);
    } else {
      this.refCache[key].value = value;
    }

    return this.refCache[key];
  },

  getBoolRef(key, defaultValue = undefined) {
    var value = window?.CONFIG?.[key];
    if (typeof value == "undefined") {
      value = defaultValue;
    } else if (typeof value == "boolean") {
      // do nothing
    } else {
      value = value + "";
      value = value.trim().replace(/\s+/g, "").toLowerCase();

      if (value == "true" || value == "1" || value == "yes" || value == "enabled") {
        value = true;
      } else if (value === "false" || value == "0" || value == "no" || value == "disabled") {
        value = false;
      } else {
        value = defaultValue;
      }
    }

    if (!this.refCache[key]) {
      this.refCache[key] = ref(value);
    } else {
      this.refCache[key].value = value;
    }

    return this.refCache[key];
  },

  getObjectRef(key, defaultValue = {}) {
    var value = window?.CONFIG?.[key];
    if (value == undefined || value == null) {
      value = defaultValue;
    } else if (typeof value == "object") {
      // do nothing
    } else if (typeof value == "string") {
      try {
        value = JSON.parse(value);
      } catch (error) {
        console.error(error);
        value = defaultValue;
      }
    } else {
      value = defaultValue;
    }

    if (!this.refCache[key]) {
      this.refCache[key] = ref(value);
    } else {
      this.refCache[key].value = value;
    }

    return this.refCache[key];
  },

  getString(key, defaultValue = undefined) {
    return this.getStringRef(key, defaultValue).value;
  },
  getDouble(key, defaultValue = undefined) {
    return this.getDoubleRef(key, defaultValue).value;
  },
  getInt(key, defaultValue = undefined) {
    return this.getIntRef(key, defaultValue).value;
  },
  getBool(key, defaultValue = undefined) {
    return this.getBoolRef(key, defaultValue).value;
  },
  getObject(key, defaultValue = {}) {
    return this.getObjectRef(key, defaultValue).value;
  },
};
